import { Fragment } from 'react';

import type { ReactElement } from '@wordpress/element/build-types/serialize';

import type { Placement, SectionDecorationVariations } from '@/src/Types/Shared/Common';
import { Bubble, Wave } from '@Views/Shared/Icons';

type DecorationType = {
	type?: SectionDecorationVariations;
	children: ReactElement;
	placement?: Placement;
	pathClassName?: string;
	pathClassNameRightCircle?: string;
	isSectionDecorated?: boolean;
	isFooter?: boolean;
};

export default function Decorations(props: DecorationType) {
	const {
		type,
		children,
		placement,
		pathClassName = '',
		pathClassNameRightCircle = '',
		isSectionDecorated = false,
		isFooter = false,
	} = props;

	return (
		<>
			{isSectionDecorated && !isFooter ? (
				<>
					{type === 'wave' ? (
						<Fragment>
							{placement?.order != 0 && (
								<Wave className='minos-decoration-wave' pathClassName={pathClassName} />
							)}
						</Fragment>
					) : (
						<>
							{placement && placement.order % 2 != 0 && (
								<Fragment data-aos='fade-right'>
									<Bubble
										position='right'
										className='minos-decoration-bubble-right'
										pathClassName={pathClassNameRightCircle}
									/>
								</Fragment>
							)}
						</>
					)}
				</>
			) : (
				/* No circle decoration on footer */
				''
			)}

			{isSectionDecorated && isFooter && type === 'wave' ? (
				<>
					{placement?.order != 0 && (
						<Wave className='minos-decoration-wave' pathClassName={pathClassName} />
					)}
				</>
			) : (
				''
			)}

			{children}

			{isSectionDecorated && type === 'bubble' && !isFooter ? (
				<>
					{placement && placement.order % 2 === 0 && (
						// even
						<Fragment data-aos='fade-left'>
							<Bubble
								position='left'
								className='minos-decoration-bubble-left'
								pathClassName={pathClassName}
							/>
						</Fragment>
					)}
				</>
			) : (
				/* No circle decoration on footer */
				''
			)}
		</>
	);
}
